import { StoreSettingDetailGetAllResponse } from 'features/Store/models';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import MenuBookRowList from '../MenuBookRowList';
import UnAssignedMenuRowList from '../UnAssignedMenuRowList';

export interface StoreSettingDetailTableProps {
  data: StoreSettingDetailGetAllResponse;
}

function StoreSettingDetailTable({ data }: StoreSettingDetailTableProps) {
  const { t } = useTranslation();

  return (
    <div
      className="dan-sticky-table flex-grow-1 flex-shrink-1 render-visible1"
      style={{ fontSize: 11, overflowX: 'hidden' }}
    >
      <div className="dan-table">
        <div className="dan-thead">
          <div className="dan-tr">
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[0]}%` }}>
              {t('StoreSettingDetailPage.menu_book')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[1]}%` }}>
              {t('StoreSettingDetailPage.course')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[2]}%` }}>
              {t('StoreSettingDetailPage.genre')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[3]}%` }}>
              {t('StoreSettingDetailPage.subgenre')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[4] + COLUMN_WIDTH[5]}%` }}>
              {t('StoreSettingDetailPage.menu')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[6]}%` }}>
              {t('StoreSettingDetailPage.mo_display')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[7] + COLUMN_WIDTH[8]}%` }}>
              {t('StoreSettingDetailPage.sub_menu_group')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[9] + COLUMN_WIDTH[10]}%` }}>
              {t('StoreSettingDetailPage.sub_menu')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[11]}%` }}>
              {t('StoreSettingDetailPage.mo_display')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[12] + COLUMN_WIDTH[13]}%` }}>
              {t('StoreSettingDetailPage.sub_menu_group')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[14] + COLUMN_WIDTH[15]}%` }}>
              {t('StoreSettingDetailPage.sub_menu')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[16]}%` }}>
              {t('StoreSettingDetailPage.mo_display')}
            </div>
          </div>
          <div className="dan-tr">
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[0]}%` }}></div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[1]}%` }}></div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[2]}%` }}></div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[3]}%` }}></div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[4]}%` }}>
              {t('StoreSettingDetailPage.name')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[5]}%` }}>
              {t('StoreSettingDetailPage.pos_code')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[6]}%` }}>
              {t('StoreSettingDetailPage.enable_or_disable')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[7]}%` }}>
              {t('StoreSettingDetailPage.name')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[8]}%` }}>
              {t('StoreSettingDetailPage.sub_menu_group_cd')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[9]}%` }}>
              {t('StoreSettingDetailPage.name')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[10]}%` }}>
              {t('StoreSettingDetailPage.pos_code')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[11]}%` }}>
              {t('StoreSettingDetailPage.enable_or_disable')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[12]}%` }}>
              {t('StoreSettingDetailPage.name')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[13]}%` }}>
              {t('StoreSettingDetailPage.sub_menu_group_cd')}
            </div>

            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[14]}%` }}>
              {t('StoreSettingDetailPage.name')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[15]}%` }}>
              {t('StoreSettingDetailPage.pos_code')}
            </div>
            <div className="dan-th" style={{ width: `${COLUMN_WIDTH[16]}%` }}>
              {t('StoreSettingDetailPage.enable_or_disable')}
            </div>
          </div>
        </div>
        <div className="position-sticky">
          {data?.unassigned_menus && <UnAssignedMenuRowList menus={data.unassigned_menus} />}
          {data?.menu_books && <MenuBookRowList menuBookList={data.menu_books}></MenuBookRowList>}

          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH[0]}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH[0] + COLUMN_WIDTH[1]}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH[0] + COLUMN_WIDTH[1] + COLUMN_WIDTH[2]}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 4).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 5).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 6).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 7).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 8).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 9).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 10).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 11).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 12).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 13).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 14).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 15).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 16).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: `${COLUMN_WIDTH.slice(0, 17).reduce((sum, width) => sum + width, 0)}%`,
              width: '1px',
              height: '100%',
              background: '#ced4da',
              zIndex: 1,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default memo(StoreSettingDetailTable);
